import React from 'react';
import { ErrorTemplate } from 'ui/templates';
const Error = () => (React.createElement(ErrorTemplate, null));
export default Error;
